import React from 'react';
import type { ReactNode } from 'react';
import { presentationTableProps } from '../render/table';

type GroupedRowLaneProps = {
  children: ReactNode;
};

export function GroupedRowLane({ children }: GroupedRowLaneProps) {
  const tableProps = presentationTableProps();

  return (
    <table
      {...tableProps}
      className={"email-builder-grouped-row-lane"}
      style={{
        ...tableProps.style,
        tableLayout: 'fixed',
      }}>
      <tbody>
        <tr>
          <td>{children}</td>
        </tr>
      </tbody>
    </table>
  );
}
